import * as zenscroll from 'zenscroll';

// Setup zenscroll
export const scrollWindow = zenscroll.createScroller(
    (document.scrollingElement || document.body) as any,
    500,
    64
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/events/scroll.ts